import React from 'react'
import NavBar from '../Component/Nav/NavBar'
import Home from '../Component/Home/Home'

const LandingPage = () => {
  return (
    <main>
      <NavBar />
      <Home />
    </main>
  )
}

export default LandingPage
